import provider from '@/api/apollo-client';
import { ref } from '@vue/composition-api';

export default function(schemas, isCache) {
  const item = ref({});
  const loading = ref(true);
  const saving = ref(false);
  const isNoCache = ref(isCache);

  function load(id, isMethodCache) {
    loading.value = true;
    return provider
      .query({
        query: schemas.load,
        variables: {
          id
        },
        fetchPolicy: isNoCache.value || isMethodCache ? 'no-cache' : ''
      })
      .finally(() => {
        loading.value = false;
      });
  }

  function getLogs(id) {
    loading.value = true;
    return provider.query({
      query: schemas.logs,
      variables: {
        id
      },
      fetchPolicy: isNoCache.value ? 'no-cache' : ''
    });
  }

  function remove(ids) {
    saving.value = true;
    const prs = [];
    ids.forEach(i => {
      prs.push(
        provider.mutate({
          mutation: schemas.remove,
          variables: {
            input: { id: i }
          },
          fetchPolicy: 'no-cache'
        })
      );
    });
    return Promise.all(prs).finally(() => {
      saving.value = false;
    });
  }

  function update(id, data) {
    loading.value = true;
    return provider
      .mutate({
        mutation: schemas.update,
        variables: {
          input: {
            id,
            patch: data
          }
        },
        fetchPolicy: 'no-cache'
      })
      .finally(() => {
        loading.value = false;
      });
  }

  return {
    loading,
    remove,
    saving,
    item,
    load,
    getLogs,
    update,
    isNoCache
  };
}
